import { render, staticRenderFns } from "./WebinarListItemTable.vue?vue&type=template&id=0995b7b8&scoped=true&"
import script from "./WebinarListItemTable.vue?vue&type=script&lang=ts&"
export * from "./WebinarListItemTable.vue?vue&type=script&lang=ts&"
import style0 from "./WebinarListItemTable.vue?vue&type=style&index=0&id=0995b7b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995b7b8",
  null
  
)

export default component.exports